import { render, staticRenderFns } from "./HeadMetadata.vue?vue&type=template&id=6dc9a87e&"
import script from "./HeadMetadata.vue?vue&type=script&lang=ts&"
export * from "./HeadMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports